import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ZonasService extends ApiService {
  entityType = EntityType.ZONA;
  url = 'api/zonas/';
}
